import Vue from 'vue'
import VueRouter from 'vue-router'
import ComingSoon from '@/views/ComingSoon.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'ComingSoon',
    component: ComingSoon
  }
]

const router = new VueRouter({
  routes
})

export default router
